export const itemHasCheckbox = (item, defaultCheckbox) => item.checkbox ?? defaultCheckbox;
const filterWithCase = (stringToFilter, filter, matchCase) => matchCase
    ? stringToFilter.includes(filter)
    : stringToFilter.toLowerCase().includes(filter.toLowerCase());
const filterWithString = (stringToFilter, filter, filterOptions) => typeof filter === "object"
    ? stringToFilter.match(filter) !== null
    : filterWithCase(stringToFilter, filter, filterOptions?.matchCase);
const filterDictionary = {
    caption: (item, filterInfo) => filterInfo.filter
        ? filterWithString(item.caption ?? "", filterInfo.filter, filterInfo.filterOptions)
        : true,
    checked: (item, filterInfo) => itemHasCheckbox(item, filterInfo.defaultCheckbox) &&
        !item.indeterminate &&
        (item.checked ?? filterInfo.defaultChecked),
    list: (item, filterInfo) => filterInfo.filterSet.has(item.id),
    metadata: (item, filterInfo) => filterInfo.filter
        ? filterWithString(item.metadata ?? "", filterInfo.filter, filterInfo.filterOptions)
        : true,
    none: () => true,
    unchecked: (item, filterInfo) => itemHasCheckbox(item, filterInfo.defaultCheckbox) &&
        !item.indeterminate &&
        !(item.checked ?? filterInfo.defaultChecked)
};
export const computeFilter = (filterType, item, filterInfo) => filterInfo.filterOptions?.hideMatchesAndShowNonMatches === true
    ? !filterDictionary[filterType](item, filterInfo)
    : filterDictionary[filterType](item, filterInfo);
export function simplifyModel(model) {
    const items = model.items;
    if (!items) {
        return [];
    }
    const simplifiedModel = items.map(item => ({
        id: item.id,
        items: simplifyModel(item)
    }));
    return simplifiedModel;
}
export const prettyPrint = (value) => JSON.stringify(value, undefined, 2);
